module.exports = __webpack_public_path__ + "static/media/WoodSplit_After.65628ec7.jpg";